var _rect, _rect2, _rect3, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _tspan0, _tspan1, _tspan10, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _rect1, _rect10, _line, _path, _rect11, _path2, _g10, _g11, _g12, _g13, _g14, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g15, _g16, _g17, _g18, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _rect20, _tspan38, _line2, _path11, _rect21, _tspan39, _rect22, _tspan40, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _path12, _path13, _path14, _tspan41, _tspan42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackCircuitDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1667,
    height: 900,
    viewBox: "0 0 1667 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1667,
    height: 900,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Track Circuit Diagram"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1667,
    height: 900,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Monitored_Value"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 712.5,
    y: 123.5,
    width: 133,
    height: 34,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Track_Gear_Name",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 741,
    y: 146.455
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "Choke",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 731,
    y: 347.455
  }, "Choke"))), /*#__PURE__*/React.createElement("text", {
    id: "Choke_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 788,
    y: 365.455
  }, "Choke"))), /*#__PURE__*/React.createElement("text", {
    id: "TrackName2_TR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1002,
    y: 470.864
  }, "......... "))), /*#__PURE__*/React.createElement("text", {
    id: "TrackName2_TR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 1035,
    y: 470.864
  }, "TPR"))), /*#__PURE__*/React.createElement("text", {
    id: "TrackName2_TR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 1036,
    y: 500.864
  }, "TPR"))), /*#__PURE__*/React.createElement("text", {
    id: "ELD EXT",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1194,
    y: 639.864
  }, "ELD EXT"))), /*#__PURE__*/React.createElement("text", {
    id: "ELD TRK",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1193,
    y: 748.864
  }, "ELD TRK"))), /*#__PURE__*/React.createElement("text", {
    id: "TrackName3_TR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1002,
    y: 500.864
  }, ".........."))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 827.5,
    y: 419.5,
    width: 75,
    height: 38,
    rx: 4.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Track_Feed_Charger_Status",
    x: 664.5,
    y: 629.5,
    width: 70,
    height: 26,
    rx: 4.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 1243.5,
    y: 575.5,
    width: 138,
    height: 40,
    rx: 4.5,
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    x: 1451.5,
    y: 575.5,
    width: 138,
    height: 40,
    rx: 4.5,
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 739.5,
    y: 604.5,
    width: 140,
    height: 38,
    rx: 4.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 1243.5,
    y: 683.5,
    width: 138,
    height: 40,
    rx: 4.5,
    stroke: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 20",
    x: 1451.5,
    y: 683.5,
    width: 138,
    height: 40,
    rx: 4.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TFC",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 676,
    y: 650.273
  }, "TFC"))), /*#__PURE__*/React.createElement("text", {
    id: "TrackName1_TR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 832,
    y: 444.455
  }, " ....... "))), /*#__PURE__*/React.createElement("text", {
    id: "TrackName1_TR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 869,
    y: 444.455
  }, "TR")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_2",
    x: 678,
    y: 293.5,
    width: 7,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123",
    cx: 681.5,
    cy: 297.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124",
    cx: 681.5,
    cy: 308.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683",
    d: "M681.5 251V297",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684",
    d: "M681.5 309V324",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_3",
    x: 715,
    y: 277.5,
    width: 7,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_2",
    cx: 718.5,
    cy: 281.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_2",
    cx: 718.5,
    cy: 292.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_2",
    d: "M718.5 256V281",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_2",
    d: "M718.5 293V316.5",
    stroke: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_4",
    x: 678.5,
    y: 517.5,
    width: 7,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_3",
    cx: 682,
    cy: 521.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_3",
    cx: 682,
    cy: 532.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_3",
    d: "M682 474V521",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_3",
    d: "M682 533V591.5",
    stroke: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_5",
    x: 838,
    y: 277.5,
    width: 7,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_4",
    cx: 841.5,
    cy: 281.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_4",
    cx: 841.5,
    cy: 292.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_4",
    d: "M841.5 257V281",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_4",
    d: "M841.5 293V316.5",
    stroke: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_6",
    x: 886,
    y: 269.5,
    width: 7,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_5",
    cx: 889.5,
    cy: 273.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_5",
    cx: 889.5,
    cy: 284.5,
    r: 1,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_5",
    d: "M889.5 253V273",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_5",
    d: "M889.5 285V308.5",
    stroke: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_7",
    x: 910.75,
    y: 488.25,
    width: 7,
    height: 21,
    transform: "rotate(-90 910.75 488.25)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_6",
    cx: 914.75,
    cy: 484.75,
    r: 1,
    transform: "rotate(-90 914.75 484.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_6",
    cx: 925.75,
    cy: 484.75,
    r: 1,
    transform: "rotate(-90 925.75 484.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_6",
    d: "M841.25 484.75H914.25",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_6",
    d: "M926.25 484.75H967",
    stroke: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_8",
    x: 979.75,
    y: 488.25,
    width: 7,
    height: 21,
    transform: "rotate(-90 979.75 488.25)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_7",
    cx: 983.75,
    cy: 484.75,
    r: 1,
    transform: "rotate(-90 983.75 484.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_7",
    cx: 994.75,
    cy: 484.75,
    r: 1,
    transform: "rotate(-90 994.75 484.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_7",
    d: "M963.25 484.75H983.25",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_7",
    d: "M995.25 484.75L1157.75 484.75",
    stroke: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_9",
    x: 979.75,
    y: 515.25,
    width: 7,
    height: 21,
    transform: "rotate(-90 979.75 515.25)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_8",
    cx: 983.75,
    cy: 511.75,
    r: 1,
    transform: "rotate(-90 983.75 511.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_8",
    cx: 994.75,
    cy: 511.75,
    r: 1,
    transform: "rotate(-90 994.75 511.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_8",
    d: "M963.25 511.75H983.25",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_8",
    d: "M995.25 511.75L1157.75 511.75",
    stroke: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Terminal_9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_10",
    x: 910.75,
    y: 515.25,
    width: 7,
    height: 21,
    transform: "rotate(-90 910.75 515.25)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 123_9",
    cx: 914.75,
    cy: 511.75,
    r: 1,
    transform: "rotate(-90 914.75 511.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 124_9",
    cx: 925.75,
    cy: 511.75,
    r: 1,
    transform: "rotate(-90 925.75 511.75)",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683_9",
    d: "M887.25 511.75H914.25",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 684_9",
    d: "M926.25 511.75H963.75",
    stroke: "black"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Coil2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 148",
    d: "M718 316C727.758 315.463 727.995 328.388 719.195 327.564",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 149",
    d: "M719.195 324.268C729.169 323.445 727.995 336.628 719.195 335.804",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 150",
    d: "M719.195 332.508C729.169 331.684 727.995 344.867 719.195 344.043",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 151",
    d: "M719.195 340.747C729.169 339.923 727.995 353.106 719.195 352.282",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 157",
    d: "M719.195 365.465C729.169 364.641 729.242 375.537 719.195 375.537",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 158",
    d: "M719.195 357.226C729.169 356.402 727.995 369.585 719.195 368.761",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 152",
    d: "M719.195 348.986C729.169 348.162 727.995 361.345 719.195 360.521",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 153",
    d: "M719.196 324.269C715.675 325.092 716.849 327.564 719.489 327.564",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 154",
    d: "M719.196 340.747C715.675 341.571 716.849 344.043 719.489 344.043",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 155",
    d: "M719.196 332.508C715.675 333.332 716.849 335.804 719.489 335.804",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 156",
    d: "M719.196 348.986C715.675 349.81 716.849 352.282 719.489 352.282",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 159",
    d: "M719.196 365.465C715.675 366.289 716.849 368.761 719.489 368.761",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 160",
    d: "M719.196 357.226C715.675 358.05 716.849 360.521 719.489 360.521",
    stroke: "black"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Coil1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 148_2",
    d: "M841 317C850.758 316.463 850.995 329.388 842.195 328.564",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 149_2",
    d: "M842.195 325.268C852.169 324.445 850.995 337.628 842.195 336.804",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 150_2",
    d: "M842.195 333.508C852.169 332.684 850.995 345.867 842.195 345.043",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 151_2",
    d: "M842.195 341.747C852.169 340.923 850.995 354.106 842.195 353.282",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 157_2",
    d: "M842.195 366.465C852.169 365.641 852.242 376.537 842.195 376.537",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 158_2",
    d: "M842.195 358.226C852.169 357.402 850.995 370.585 842.195 369.761",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 152_2",
    d: "M842.195 349.986C852.169 349.162 850.995 362.345 842.195 361.521",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 153_2",
    d: "M842.196 325.269C838.675 326.092 839.849 328.564 842.489 328.564",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 154_2",
    d: "M842.196 341.747C838.675 342.571 839.849 345.043 842.489 345.043",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 155_2",
    d: "M842.196 333.508C838.675 334.332 839.849 336.804 842.489 336.804",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 156_2",
    d: "M842.196 349.986C838.675 350.81 839.849 353.282 842.489 353.282",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 159_2",
    d: "M842.196 366.465C838.675 367.289 839.849 369.761 842.489 369.761",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 160_2",
    d: "M842.196 358.226C838.675 359.05 839.849 361.521 842.489 361.521",
    stroke: "black"
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 673.5,
    y: 325.5,
    width: 18,
    height: 16,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 880.5,
    y: 298.5,
    width: 18,
    height: 16,
    fill: "#D9D9D9",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 686",
    x1: 719.5,
    y1: 375.002,
    x2: 718.5,
    y2: 629.002,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 687",
    d: "M606.963 333.5H674.037",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18_2",
    x: 673.5,
    y: 458.5,
    width: 18,
    height: 16,
    fill: "#D9D9D9",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line 688",
    d: "M608.963 466.5H674.037",
    stroke: "black"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Variable_Resistance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 161",
    d: "M681.5 381.5L689 385.5L673 389.5L689 394L673 399.5L689 404.5L673 408L682 411",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 689",
    d: "M681.5 341V382",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 690",
    d: "M681.5 411V459",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 22",
    d: "M699.494 383.075C699.536 382.802 699.348 382.547 699.075 382.506L694.626 381.832C694.353 381.79 694.098 381.978 694.056 382.251C694.015 382.524 694.203 382.779 694.476 382.82L698.431 383.419L697.832 387.374C697.79 387.647 697.978 387.902 698.251 387.944C698.524 387.985 698.779 387.797 698.82 387.524L699.494 383.075ZM661.297 411.403L699.297 383.403L698.703 382.597L660.703 410.597L661.297 411.403Z",
    fill: "black"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "ByPass_Connection2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 162",
    d: "M718.5 245C729.5 244 730 256.5 718.5 256.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 691",
    d: "M718.5 245.454V195",
    stroke: "black"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "ByPass_Connection1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 162_2",
    d: "M842 246C853 245 853.5 257.5 842 257.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 691_2",
    d: "M842 246.454V196",
    stroke: "black"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "ByPass_Connection1_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 162_3",
    d: "M887 563C898 562 898.5 574.5 887 574.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 691_3",
    d: "M887 563.454V511.239",
    stroke: "black"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "PFC_Contact"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 692",
    d: "M681.64 606.156V629",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 693",
    d: "M681.5 606.5L694.5 593",
    stroke: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 125",
    cx: 682,
    cy: 591.5,
    r: 1.5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 126",
    cx: 695,
    cy: 592.5,
    r: 1.5,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 127",
    cx: 682,
    cy: 605.5,
    r: 1.5,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line 694",
    d: "M842.5 375.995L842.52 418.995",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line 697",
    d: "M841.422 484.207L842 567.5",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line 702",
    d: "M680.422 655.207L680.422 756",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line 699",
    d: "M887.422 574.207L888 647.5",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line 698",
    d: "M815.286 567.113H1564.5",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line 700",
    d: "M815.286 648.113H1374.5",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Line 701",
    d: "M642.286 675.113H1565.5",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Line 703",
    d: "M642.286 757.113H1374.5",
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Line 695",
    d: "M889.5 313.995L889.52 418.995",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Line 696",
    d: "M921.5 384.995L921.52 480.995",
    stroke: "black"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "ELD1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ELD_VS-B24NTPR",
    x: 1197.5,
    y: 587.5,
    width: 39,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 704",
    x1: 1218,
    y1: 587.013,
    x2: 1218,
    y2: 566.988,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 705",
    d: "M1218 616.013V608.988",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 706",
    d: "M1210.49 615.5H1225.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 707",
    d: "M1212.49 621.5H1221.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 708",
    d: "M1211.49 618.5H1223.49",
    stroke: "black"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "ELD1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ELD_VS-B24STPR",
    x: 1404.5,
    y: 587.5,
    width: 39,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 704_2",
    x1: 1425,
    y1: 587.013,
    x2: 1425,
    y2: 566.988,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 705_2",
    d: "M1425 616.013V608.988",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 706_2",
    d: "M1417.49 615.5H1432.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 707_2",
    d: "M1419.49 621.5H1428.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 708_2",
    d: "M1418.49 618.5H1430.49",
    stroke: "black"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "ELD1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ELD_VS-2BX110",
    x: 1197.5,
    y: 695.5,
    width: 39,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 704_3",
    x1: 1218,
    y1: 695.013,
    x2: 1218,
    y2: 674.988,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 705_3",
    d: "M1218 724.013V716.988",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 706_3",
    d: "M1210.49 723.5H1225.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 707_3",
    d: "M1212.49 729.5H1221.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 708_3",
    d: "M1211.49 726.5H1223.49",
    stroke: "black"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "ELD1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ELD_VS-4BX110",
    x: 1404.5,
    y: 695.5,
    width: 39,
    height: 21,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 704_4",
    x1: 1425,
    y1: 695.013,
    x2: 1425,
    y2: 674.988,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 705_4",
    d: "M1425 724.013V716.988",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 706_4",
    d: "M1417.49 723.5H1432.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 707_4",
    d: "M1419.49 729.5H1428.49",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 708_4",
    d: "M1418.49 726.5H1430.49",
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Track Feed Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 231.273
  }, "Track Feed Voltage"))), /*#__PURE__*/React.createElement("text", {
    id: "Track Relay Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1092,
    y: 231.273
  }, "Track Relay Voltage"))), /*#__PURE__*/React.createElement("text", {
    id: "IPS ROOM",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1257,
    y: 539.273
  }, "IPS ROOM"))), /*#__PURE__*/React.createElement("text", {
    id: "VS-PTD&TPRN",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1257,
    y: 602.273
  }, ".................."))), /*#__PURE__*/React.createElement("text", {
    id: "VS-PTD&TPRS",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 1464,
    y: 602.273
  }, ".................."))), /*#__PURE__*/React.createElement("text", {
    id: "VS-TRACKN",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 1257,
    y: 711.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "VS-TRACKS",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 1467,
    y: 711.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "Track Relay Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1092,
    y: 318.273
  }, "Track Relay Current"))), /*#__PURE__*/React.createElement("text", {
    id: "TPR Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 1092,
    y: 393.273
  }, "TPR Voltage"))), /*#__PURE__*/React.createElement("text", {
    id: "Indoor TPR Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1092,
    y: 440.273
  }, "Indoor TPR Voltage"))), /*#__PURE__*/React.createElement("text", {
    id: "Track Feed Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 341.273
  }, "Track Feed Current"))), /*#__PURE__*/React.createElement("text", {
    id: "Track Charger Output Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 462.273
  }, "Track Charger")), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 486.273
  }, "Output Current"))), /*#__PURE__*/React.createElement("text", {
    id: "Track Charger Output Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 537.273
  }, "Track Charger")), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 561.273
  }, "Output Voltage"))), /*#__PURE__*/React.createElement("text", {
    id: "24V_DC_Busbar",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 743,
    y: 629.545
  }, "24V DC-Busbar"))), /*#__PURE__*/React.createElement("text", {
    id: "Track Charger Input Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 724.273
  }, "Track Charger")), _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 748.273
  }, "Input Voltage"))), /*#__PURE__*/React.createElement("text", {
    id: "110V AC TRK - Busbar",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 695,
    y: 747.273
  }, "110V AC TRK - Busbar"))), /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_TRACK_VALUE"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_FEED_VOLTAGE",
    x: 474.5,
    y: 197.5,
    width: 133,
    height: 51,
    rx: 4.5,
    stroke: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_FEED_CURRENT",
    x: 474.5,
    y: 315.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_CHARGER_OUTPUT_CURRENT",
    x: 475.5,
    y: 448.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_CHARGER_OUTPUT_VOLTAGE",
    x: 475.5,
    y: 515.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_CHARGER_INPUT_VOLTGAE",
    x: 475.5,
    y: 708.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_RELAY_VOLTAGE",
    x: 950.5,
    y: 197.5,
    width: 133,
    height: 51,
    rx: 4.5,
    stroke: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_RELAY_CURRENT",
    x: 950.5,
    y: 293.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_24V_TPR",
    x: 950.5,
    y: 366.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_IF",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 504,
    y: 342.273
  }, "00.00V"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_VF",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 504,
    y: 230.273
  }, "00.00V"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_ICO",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 509,
    y: 477.273
  }, "00.00A"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_VCO",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 509,
    y: 541.273
  }, "00.00V"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_VCI",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 507,
    y: 736.273
  }, "00.00V"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_VR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 984,
    y: 230.273
  }, "00.00V"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_IR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 985,
    y: 319.273
  }, "00.00V"))), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_TPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 985,
    y: 392.273
  }, "00.00V"))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "TRACK_24V_INDOOR_TPR",
    x: 950.5,
    y: 415.5,
    width: 133,
    height: 38,
    rx: 4.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TRACK_INDOOR_TPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 985,
    y: 441.273
  }, "00.00V")))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line 709",
    x1: 898,
    y1: 305.5,
    x2: 950,
    y2: 305.5,
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line 710",
    d: "M921 385.5H951",
    stroke: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19_2",
    x: 1180.5,
    y: 544.5,
    width: 426,
    height: 234,
    rx: 9.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PFC",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 637,
    y: 587.273
  }, "PFC"))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    x: 43.5,
    y: 34.5,
    width: 1576,
    height: 809,
    rx: 11.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "LIVE TRACK CIRCUIT MONITORING STATUS",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 25,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 523,
    y: 70.0909
  }, " LIVE TRACK CIRCUIT MONITORING STATUS"))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line 711",
    x1: 670.5,
    y1: 194,
    x2: 670.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line 712",
    x1: 681.5,
    y1: 194,
    x2: 681.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line 713",
    x1: 692.5,
    y1: 194,
    x2: 692.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line 714",
    x1: 704.5,
    y1: 194,
    x2: 704.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line 715",
    x1: 659.5,
    y1: 194,
    x2: 659.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line 716",
    x1: 837.5,
    y1: 194,
    x2: 837.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line 717",
    x1: 848.5,
    y1: 194,
    x2: 848.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "Line 718",
    x1: 859.5,
    y1: 194,
    x2: 859.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "Line 719",
    x1: 871.5,
    y1: 194,
    x2: 871.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line 720",
    x1: 826.5,
    y1: 194,
    x2: 826.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line 726",
    x1: 780.5,
    y1: 194,
    x2: 780.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line 727",
    x1: 791.5,
    y1: 194,
    x2: 791.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line 728",
    x1: 802.5,
    y1: 194,
    x2: 802.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line 729",
    x1: 814.5,
    y1: 194,
    x2: 814.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line 730",
    x1: 769.5,
    y1: 194,
    x2: 769.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line 731",
    x1: 728.5,
    y1: 194,
    x2: 728.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "Line 732",
    x1: 737.5,
    y1: 194,
    x2: 737.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "Line 733",
    x1: 748.5,
    y1: 194,
    x2: 748.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "Line 734",
    x1: 759.5,
    y1: 194,
    x2: 759.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "Line 735",
    x1: 714.5,
    y1: 194,
    x2: 714.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "Line 721",
    x1: 892.5,
    y1: 194,
    x2: 892.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "Line 722",
    x1: 903.5,
    y1: 194,
    x2: 903.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "Line 723",
    x1: 914.5,
    y1: 194,
    x2: 914.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "Line 724",
    x1: 926.5,
    y1: 194,
    x2: 926.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "Line 725",
    x1: 881.5,
    y1: 194,
    x2: 881.5,
    y2: 251,
    stroke: "#DFD3D3",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 163",
    d: "M513.5 76V88.5H1062.5V76",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "UPSIDE_Track",
    d: "M645.01 193.5L936.01 195.44",
    stroke: "black",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "DOWNSIDE_Track",
    d: "M646.01 250.5L937.01 252.44",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "Leakage Current =",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 716,
    y: 186.864
  }, "Leakage Current ="))), /*#__PURE__*/React.createElement("text", {
    id: "Leakage_Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 829,
    y: 186.864
  }, "..........")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackCircuitDiagram);
export default __webpack_public_path__ + "static/media/track_circuit_diagram.de23546018483aa1fe6e3e122d55e5f1.svg";
export { ForwardRef as ReactComponent };